// extracted by mini-css-extract-plugin
export default {"description":"BaseSources_description_m8FVx"};